<template>
    <div>logout</div>
</template>

export 

<script>
export default {
    created() {
        this.$store.dispatch('logout')
        .then(this.$router.push({name: 'login'}))
    }
}
</script>

<style>

</style>